// js/custom-element/section/facet/sort-by-popover.js
if (!customElements.get('sort-by-popover')) {
  var SortByPopover = class extends PopoverContent {
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on('change', '[name="sort_by"]', this._onSortChanged.bind(this));
    }
    _onSortChanged(event, target) {
      const currentUrl = new URL(location.href);
      currentUrl.searchParams.set('sort_by', target.value);
      currentUrl.searchParams.delete('page');
      this.open = false;
      this.dispatchEvent(
        new CustomEvent('facet:criteria-changed', {
          bubbles: true,
          detail: {
            url: currentUrl.toString(),
          },
        })
      );
    }
  };
  window.customElements.define('sort-by-popover', SortByPopover);
}
